import { Box, SxProps, Typography } from "@mui/material";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { sxBoxInfoLabel, sxLabel, sxValue } from "./sxProps";
import parse from "html-react-parser";


interface InfoLabelProps {
    label: string,
    value: string | React.ReactNode
}

const InfoLabel: React.FC<InfoLabelProps> = ({ label, value }) => {

    const { textStyleAccessibility } = useAccessibility();

    const returnKeyFormattedText = (key: string): string => {
        switch (key) {
            case "medico": return "Profissional:";
            case "especialidade": return "Especialidade:";
            case "endereco": return "Endereço:";
            case "telefone": return "Telefone:";
            case "dataHoraAgendamento": return "Data e hora da consulta:";
            case "tipoAtend": return "Tipo da consulta:";
            case "dataConfirmacao": return "Data da confirmação:";
            case "status": return "Status:";
            default: return "";
        }
    };

    // const getStatusDetailSx = (): SxProps => {
    //     // switch (scheduleDetailValue) {
    //     //     case 'confirmado': case 'concluido':
    //     //         return sxScheduleDetailStatusGreen;
    //     //     case 'agendado':
    //     //         return sxScheduleDetailStatusYellow;
    //     //     case 'cancelado': case 'faltou':
    //     //         return sxScheduleDetailStatusRed;
    //     //     default:
    //     //         return sxScheduleDetailValueStandard;
    //     // }
    // }

    return (
        <Box sx={sxBoxInfoLabel}>
            <Typography style={textStyleAccessibility} sx={sxLabel}>{label}</Typography>
            <Typography style={textStyleAccessibility} sx={sxValue}>{typeof value === 'string' ? parse(value || "") : value}</Typography>
        </Box>
    )
}

export default InfoLabel;